import React, { useState, useEffect } from 'react'
import URL from '../../../../_Components/URL';
import Profile from '../../../../_Components/Profile';

import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { alertActions } from '../../../../../../_actions/alert.actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { Container, Card, Col, Row } from 'react-bootstrap';

export default function ViewProfile({ client, licensedUser }) {
  const dispatch = useDispatch()

  const [licensed, setLicensed] = useState({});
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    setLicensed(licensedUser)
  }, [licensedUser])

  return <Container>
    <Row >
      <Col xs='8' className='my-auto'>
        <Row className='mb-3'>
          <Col>
            <URL urlString={`https://${licensed.licensedDomain}.${process.env.REACT_APP_DOMAIN}`} />
          </Col>
          <Col xs='auto' className='my-auto text-left'>
            <a href={`http://${licensed.licensedDomain}.${process.env.REACT_APP_DOMAIN}`} target="_blank">&nbsp;<FontAwesomeIcon icon={faExternalLinkAlt} />&nbsp;View</a>
          </Col>
        </Row>
      </Col>
      <Col xs={{ span: 2, offset: 1 }}>
        <a href={licensed.qrcodeUrl} target='_blank'>
          <div className="row">
            <div className="col-12">
              <img src={licensed.qrcodeUrl} alt='QRCode' className='img-fluid text-center' />
            </div>
            <div className="col my-auto">
              <div className='text-center'>Download</div>
            </div>
          </div>
        </a>
      </Col>
    </Row>
    <br />
    <Row>
      <Col xs='12'>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col style={{ pointerEvents: 'none' }}>
                    <Profile
                      bio={licensed.content}
                      client={client}
                      licensed={licensed}
                      uploading={uploading}
                      handleProfile={() => {}}
                      handleError={() => dispatch(alertActions.error('We could not read the file image. Please select a jpg/jpeg or png image.'))}
                    />
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <Row className='d-flex justify-content-end'>
                  <Col xs='4'>
                    <Link to={`/landing/${licensed.id}/edit`} className="btn btn-success btn-block">Edit Bio</Link>
                  </Col>
                </Row>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  </Container>
}